export default __webpack_public_path__ + "static/media/threeDots.68c0c017.svg";